// REACT
import { useState } from "react";

import { createNote } from "../api-interactions/notes";

export const QuickNotes = () => {
  const [text, setText] = useState("");

  const addNote = () => {
    createNote();
  };

  return (
    <div className="regular-list-container">
      <h2>Quick Notes</h2>
      <textarea
        onChange={(e) => setText(e.target.value)}
        id="quick-notes-text"
        placeholder="Type here..."
      />
      {text && (
        <button
          onClick={addNote}
          style={{ marginTop: "0.5rem" }}
          className="update-button"
        >
          Save
        </button>
      )}
    </div>
  );
};
